import React from 'react';
import { GeoJsonLayer } from '@deck.gl/layers';

function Ocitanja({ wfsLayers, setWfsLayers }) {

    const handleOcitanja = (type, isChecked) => {
        const layerId = `${type.toLowerCase()}-ocitanja-layer`;

        if (isChecked) {
            const mjernaMjestaLayer = wfsLayers.find(layer => layer.id === 'mjerna_mjesta-layer');

            if (mjernaMjestaLayer && mjernaMjestaLayer.props.data && mjernaMjestaLayer.props.data.features) {
                const features = mjernaMjestaLayer.props.data.features;

                const filteredMjesta = features.filter(feature => {
                    if (type === 'AMM') {
                        return feature.properties?.amm_integrisano === true;
                    } else if (type === 'Rucno') {
                        return feature.properties?.amm_integrisano === false;
                    }
                    return false;
                });

                if (filteredMjesta.length > 0) {
                    const newLayer = new GeoJsonLayer({
                        id: layerId,
                        data: {
                            type: 'FeatureCollection',
                            features: filteredMjesta
                        },
                        getFillColor: type === 'AMM' ? [0, 255, 0, 200] : [255, 255, 0, 255],
                        getPointRadius: 50,
                        pointRadiusMinPixels: 5,
                        pickable: true
                    });

                    setWfsLayers(prevLayers => [...prevLayers, newLayer]);
                }
            }
        } else {
            setWfsLayers(prevLayers => prevLayers.filter(layer => layer.id !== layerId));
        }
    };

    return (
        <div className="sub-options">
            <label className="toggle">
                <span>Ručno</span>
                <input
                    type="checkbox"
                    onChange={(e) => handleOcitanja('Rucno', e.target.checked)}
                />
                <span className="slider"></span>
            </label>

            <label className="toggle">
                <span>AMM</span>
                <input
                    type="checkbox"
                    onChange={(e) => handleOcitanja('AMM', e.target.checked)}
                />
                <span className="slider"></span>
            </label>
        </div>
    );
}

export default Ocitanja;